module.exports = __webpack_public_path__ + "static/media/prepaid recharge_1.79b5c928.png";